module.exports = __webpack_public_path__ + "static/media/mc-cormick-mayonesa-limones-006-ok-1501.69671cee.png";